import ExtensionActionDetail from 'automation-ui-action-features/actions/extension/ExtensionActionDetail';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { jsx as _jsx } from "react/jsx-runtime";
const ExtensionActionHistoryCard = ({
  action,
  actionLabel,
  actionMetadata,
  flowObjectTypeId,
  getActionLabelById,
  getActionOutputsForTargetActionById
}) => /*#__PURE__*/_jsx(LogEventRowAction, {
  title: actionLabel,
  content: /*#__PURE__*/_jsx(ExtensionActionDetail, {
    action: action,
    actionMetadata: actionMetadata,
    flowObjectTypeId: flowObjectTypeId,
    getActionLabelById: getActionLabelById,
    getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
  })
});
export default ExtensionActionHistoryCard;